import React from 'react';
import PropTypes from 'prop-types';

import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Link from '@mui/material/Link';
import {Typography} from '@mui/material';
import { grey } from '@mui/material/colors';
import {styled} from '@mui/system';

import Organization from './Organization';
import AffiliationList from './AffiliationList';
import AuthorList from './AuthorList';
import Linkout from './Linkout';
import {showActiveYears} from '../../helpers/active_years';
import {autoPluralize} from '../../helpers/pluralizer';


const StyledMetadata = styled('div')({
    margin: 0,
    padding: 0
});

const StyledDetailsIcon = styled('div')({
    float: 'right'
});

const StyledDetailsContent = styled(Collapse)({
    marginBottom: 30,
    padding: 0
});

const StyledDetailsTitle = styled(Typography)(({ theme }) =>({
    fontSize: theme.custom.font.small,
    fontWeight: theme.custom.font.bold,
    margin: '15px 0 3px 0',
    padding: 0
}));

const StyledNoData = styled('p')({
    fontStyle: 'italic'
});

const StyledLinkDefault = styled(Link)({
    textDecoration: 'none',
    '&:hover':{
        textDecoration: 'underline'
    }
});

const StyledDisabledLink = styled(StyledLinkDefault)({
    color: grey[500]
});

const StyledOrganizationsList = styled('ul')(({ theme }) =>({
    paddingLeft: theme.custom.spacing.default,
    margin: 0
}));


class GrantListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open_details: []
        };
    }

    stopPropagation = (event) => {
        event.stopPropagation();
    };

    handleDetailsClick = (event) => {
        let id = event.currentTarget.dataset.id;
        let open_details = this.state.open_details;
        let index = this.state.open_details.indexOf(id);
        if (index > -1) {
            open_details.splice(index, 1);
        }else{
            open_details.push(id);
        }
        this.setState({open_details: open_details});
    };

    detailsOpen = (id) => {
        return !!(this.state.open_details && this.state.open_details.indexOf(id) >= 0);
    };

    projectNumbers = (project_numbers_json) => {
        let project_numbers = JSON.parse(project_numbers_json);
        return (
            project_numbers.map((project_number, index) =>
                <div key={index}>
                    <StyledDetailsTitle>{project_number.label}</StyledDetailsTitle>
                    <StyledMetadata>{project_number.project_num}</StyledMetadata>
                </div>
            )
        )
    }

    render() {
        let grant = this.props.grant;
        if(grant.title){
            let StyledLink = this.props.disabled ? StyledDisabledLink : StyledLinkDefault;
            return (
                <div>
                    <StyledDetailsIcon onClick={this.handleDetailsClick} data-id={grant.id}>
                        {this.detailsOpen(grant.id) ? <ExpandLess /> : <ExpandMore />}
                    </StyledDetailsIcon>
                    <StyledLink
                        target="_blank"
                        rel="noreferrer"
                        onClick={this.stopPropagation}
                        href={`https://app.dimensions.ai/details/grant/${grant.id}`}>
                        {grant.title}</StyledLink>
                    <StyledMetadata><AuthorList authors={grant.authors} /></StyledMetadata>
                    <StyledMetadata><AffiliationList affiliations={grant.affiliations} /></StyledMetadata>
                    <StyledMetadata>{!this.props.hideYears && showActiveYears(grant.active_year)}{!this.props.hideYears && grant.active_year ? '; ' : ''}{grant.funding_org_name}</StyledMetadata>
                    {grant.linkout && <Linkout url={grant.linkout} label="fulltext" disabled={this.props.disabled}/>}

                    <StyledDetailsContent in={this.detailsOpen(grant.id)} timeout="auto" unmountOnExit>

                        {grant.org_names && <div>
                            <StyledDetailsTitle>{autoPluralize(grant.org_names.length, 'Organization')}</StyledDetailsTitle>
                            <StyledOrganizationsList>
                            {grant.org_names.map((org_name, index) =>
                                <li key={index}>
                                    <Organization organization={{name: org_name}} docDetailsStyle={true}/>
                                </li>
                            )}
                            </StyledOrganizationsList>
                        </div>}

                        {grant.project_numbers && this.projectNumbers(grant.project_numbers)}

                        {grant.publisher_place && <div>
                            <StyledDetailsTitle>Publisher Place</StyledDetailsTitle>
                            <StyledMetadata>{grant.publisher_place}</StyledMetadata>
                        </div>}

                    </StyledDetailsContent>
                </div>
            );
        }
        return (<StyledNoData>No data found for grant-ID {grant.id}</StyledNoData>);
    }

}

GrantListItem.propTypes = {
    grant: PropTypes.object.isRequired,
    hideYears: PropTypes.bool,
    disabled: PropTypes.bool
};

export default GrantListItem;
